(function () {
  const SELECTOR = '[data-hikstik-engraving]';
  const STYLE_ID = 'hikstik-engraving-styles';
  const ACCEPT = 'image/*,.jpg,.jpeg,.png,.webp,.heic,.heif,.svg,image/jpeg,image/png,image/webp,image/heic,image/heif,image/svg+xml';

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = '.hikstik-engraving__input{border:1px solid rgba(18,18,18,.55)!important;box-shadow:0 0 0 1px rgba(18,18,18,.08)!important;background-color:#fff!important;line-height:1.35!important;padding-top:1.05rem!important;padding-bottom:1.05rem!important}.hikstik-engraving__input:focus{border-color:rgba(18,18,18,.9)!important;box-shadow:0 0 0 2px rgba(18,18,18,.14)!important;outline:0}variant-selects .product-form__input--pill input[type="radio"]+label{display:inline-flex!important;align-items:center!important;justify-content:center!important;line-height:1.2!important;min-height:4.4rem!important;padding-top:.9rem!important;padding-bottom:.9rem!important;text-align:center}.hikstik-engraving__field,.hikstik-engraving__upload{margin-top:1rem}.hikstik-engraving__counter{margin:.35rem 0 0}.hikstik-engraving__native-file{position:absolute!important;width:1px!important;height:1px!important;opacity:0!important;pointer-events:none!important;overflow:hidden!important}.hikstik-engraving__choose{display:inline-flex;align-items:center;justify-content:center;min-height:4.4rem;padding:0 1.8rem;border:1px solid rgba(18,18,18,.55);background:#fff;color:rgb(18,18,18);cursor:pointer;font:inherit}.hikstik-engraving__choose:hover,.hikstik-engraving__choose:focus{border-color:rgba(18,18,18,.9);box-shadow:0 0 0 2px rgba(18,18,18,.12);outline:0}.hikstik-engraving__status{margin:.55rem 0 0;font-style:italic;color:rgba(18,18,18,.76)}.hikstik-engraving__help{margin:.35rem 0 0;color:rgba(18,18,18,.72)}.hikstik-engraving__file-list{display:grid;gap:1rem;margin:.85rem 0 0}.hikstik-engraving__file-item{display:grid;gap:.65rem;min-width:0}.hikstik-engraving__file-row{display:flex;align-items:center;justify-content:flex-start;gap:.5rem;min-width:0}.hikstik-engraving__file-name{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-style:italic}.hikstik-engraving__remove{appearance:none;border:0;background:transparent;color:rgb(18,18,18);cursor:pointer;flex:0 0 auto;font:inherit;line-height:1;padding:0 .2rem}.hikstik-engraving__remove:hover,.hikstik-engraving__remove:focus{text-decoration:underline;outline:0}.hikstik-engraving__stored-input{display:none!important}.hikstik-engraving__file-meta{display:grid;gap:.65rem}.hikstik-engraving__file-meta select,.hikstik-engraving__file-meta textarea{width:100%;min-height:4.4rem;border:1px solid rgba(18,18,18,.55);background:#fff;padding:1rem;font:inherit}.hikstik-engraving__file-meta textarea{min-height:9rem;resize:vertical}';
    document.head.appendChild(style);
  }

  function getMode(value) {
    const normalized = (value || '').toLowerCase();
    if (!normalized || normalized.includes('no engraving')) return 'none';
    if (normalized.includes('two') || normalized.includes('2')) return 'two';
    if (normalized.includes('one') || normalized.includes('1') || normalized.includes('engraving')) return 'one';
    return 'none';
  }

  function getLayout(value) {
    const normalized = (value || '').toLowerCase();
    if (normalized.includes('left') || normalized.includes('right')) {
      return { first: 'Left', second: 'Right', firstLabel: 'Left Side', secondLabel: 'Right Side' };
    }
    if (normalized.includes('front') || normalized.includes('back')) {
      return { first: 'Front', second: 'Back', firstLabel: 'Front', secondLabel: 'Back' };
    }
    return { first: 'Engraving 1', second: 'Engraving 2', firstLabel: 'Engraving 1', secondLabel: 'Engraving 2' };
  }

  function getSelectedEngravingValue(container) {
    const productInfo = container.closest('product-info') || document;
    const variantSelects = productInfo.querySelector('variant-selects');
    if (!variantSelects) return '';

    const engravingFieldset = Array.from(variantSelects.querySelectorAll('fieldset')).find((fieldset) => {
      const legend = fieldset.querySelector('legend');
      return legend && legend.textContent.trim().toLowerCase() === 'engraving';
    });

    if (engravingFieldset) return engravingFieldset.querySelector('input[type="radio"]:checked')?.value || '';

    const selects = Array.from(variantSelects.querySelectorAll('select'));
    const engravingSelect = selects.find((select) => {
      const label = productInfo.querySelector('label[for="' + CSS.escape(select.id) + '"]');
      const labelText = label?.textContent || select.name || select.id || '';
      return labelText.trim().toLowerCase() === 'engraving';
    });

    return engravingSelect?.value || '';
  }

  function getBulkEngravingNote(container) {
    const productInfo = container.closest('product-info') || document;
    const link = Array.from(productInfo.querySelectorAll('a')).find((anchor) => anchor.textContent.trim().toLowerCase().includes('bulk engraving form'));
    return link?.closest('p, div') || null;
  }

  function updateBulkEngravingNote(note) {
    if (!note || note.dataset.bulkEngravingInstruction === 'true' || note.textContent.includes('See Bulk Engraving')) return;

    const link = Array.from(note.querySelectorAll('a')).find((anchor) => anchor.textContent.trim().toLowerCase().includes('bulk engraving form'));
    if (!link) return;

    const newLink = document.createElement('a');
    newLink.href = link.href;
    newLink.textContent = link.textContent.trim() || 'Bulk Engraving Form';
    if (link.target) newLink.target = link.target;
    if (link.rel) newLink.rel = link.rel;
    if (link.className) newLink.className = link.className;

    note.textContent = '';
    note.append(
      'Ordering multiple shafts with different engravings? Use the quantity selector below, then submit each shaft\'s engraving details using our ',
      newLink,
      '. To add to cart, type "See Bulk Engraving" in each engraving field above. If all shafts have the same engraving, just enter it above and select your quantity, no form needed.'
    );
    note.dataset.bulkEngravingInstruction = 'true';
  }

  function createHidden(formId, name, value, marker) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.defaultValue = value;
    input.setAttribute('value', value);
    input.setAttribute('form', formId);
    if (marker) input.dataset[marker] = 'true';
    return input;
  }

  function ensureNoArtworkInput(upload) {
    let input = upload.querySelector('[data-engraving-no-artwork]');
    if (!input) {
      input = createHidden(upload.dataset.productFormId, 'properties[Artwork 1]', 'No artwork', 'engravingNoArtwork');
      upload.append(input);
    }
    input.name = 'properties[Artwork 1]';
    input.value = 'No artwork';
    input.defaultValue = 'No artwork';
    input.setAttribute('value', 'No artwork');
    return input;
  }

  function getStoredUploads(upload) {
    return Array.from(upload.querySelectorAll('[data-engraving-stored-upload]'));
  }

  function getFilenameProperties(upload) {
    return Array.from(upload.querySelectorAll('[data-engraving-file-name-property]'));
  }

  function getMetaControls(upload) {
    return Array.from(upload.querySelectorAll('[data-engraving-file-meta]'));
  }

  function getMetaValues(upload) {
    const values = {};
    getMetaControls(upload).forEach((meta) => {
      values[meta.dataset.uploadToken] = {
        side: meta.querySelector('[data-engraving-artwork-side]')?.value || '',
        notes: meta.querySelector('[data-engraving-artwork-notes]')?.value || ''
      };
    });
    return values;
  }

  function ensureActiveUploadInput(upload) {
    const wrapper = upload.querySelector('[data-engraving-upload-inputs]');
    let input = wrapper.querySelector('[data-engraving-upload-input]:not([data-engraving-stored-upload])');
    if (!input) {
      input = document.createElement('input');
      input.className = 'hikstik-engraving__native-file';
      input.type = 'file';
      input.name = 'properties[_Artwork File Pending]';
      input.id = 'engraving-artwork-' + upload.dataset.productFormId + '-' + Date.now();
      input.accept = ACCEPT;
      input.tabIndex = -1;
      input.setAttribute('aria-hidden', 'true');
      input.setAttribute('form', upload.dataset.productFormId);
      input.dataset.engravingUploadInput = 'true';
      wrapper.append(input);
    }
    return input;
  }

  function updateUploadStatus(upload) {
    const count = getStoredUploads(upload).length;
    const status = upload.querySelector('[data-engraving-upload-status]');
    const noArtwork = ensureNoArtworkInput(upload);
    if (status) status.textContent = count === 0 ? 'No file uploaded' : count + ' file' + (count === 1 ? '' : 's') + ' uploaded';
    noArtwork.disabled = upload.hidden || count > 0;
  }

  function renumberUploads(upload) {
    getStoredUploads(upload).forEach((input, index) => {
      input.name = 'properties[_Artwork File ' + (index + 1) + ']';
    });
    getFilenameProperties(upload).forEach((input, index) => {
      input.name = 'properties[Artwork ' + (index + 1) + ']';
    });
    getMetaControls(upload).forEach((meta, index) => {
      const number = index + 1;
      const side = meta.querySelector('[data-engraving-artwork-side]');
      const notes = meta.querySelector('[data-engraving-artwork-notes]');
      if (side) side.name = 'properties[Artwork ' + number + ' Placement]';
      if (notes) notes.name = 'properties[Artwork ' + number + ' Placement Notes]';
    });
    updateUploadStatus(upload);
  }

  function createMeta(upload, input, index, saved) {
    const container = upload.closest(SELECTOR);
    const mode = container?.dataset.engravingMode || 'none';
    const layout = getLayout(container?.dataset.engravingOption || '');
    const file = input.files && input.files[0];
    const number = index + 1;
    const meta = document.createElement('div');
    const sideId = 'artwork-side-' + upload.dataset.productFormId + '-' + number;
    const notesId = 'artwork-notes-' + upload.dataset.productFormId + '-' + number;

    meta.className = 'hikstik-engraving__file-meta';
    meta.dataset.engravingFileMeta = 'true';
    meta.dataset.uploadToken = input.dataset.uploadToken;

    if (mode === 'two') {
      const sideLabel = document.createElement('label');
      const side = document.createElement('select');
      sideLabel.className = 'form__label';
      sideLabel.setAttribute('for', sideId);
      sideLabel.textContent = 'Where should artwork ' + number + ' go?';
      side.id = sideId;
      side.name = 'properties[Artwork ' + number + ' Placement]';
      side.setAttribute('form', upload.dataset.productFormId);
      side.dataset.engravingArtworkSide = 'true';
      side.required = true;
      side.innerHTML = '<option value="">Select placement</option><option value="' + layout.first + '">' + layout.firstLabel + '</option><option value="' + layout.second + '">' + layout.secondLabel + '</option><option value="Both">Both</option>';
      side.value = saved?.side || '';
      meta.append(sideLabel, side);
    } else {
      const side = createHidden(upload.dataset.productFormId, 'properties[Artwork ' + number + ' Placement]', 'Engraving');
      side.dataset.engravingArtworkSide = 'true';
      meta.append(side);
    }

    const notesLabel = document.createElement('label');
    const notes = document.createElement('textarea');
    notesLabel.className = 'form__label';
    notesLabel.setAttribute('for', notesId);
    notesLabel.textContent = (file ? file.name + ' - ' : '') + 'Placement notes';
    notes.id = notesId;
    notes.name = 'properties[Artwork ' + number + ' Placement Notes]';
    notes.setAttribute('form', upload.dataset.productFormId);
    notes.maxLength = 300;
    notes.required = true;
    notes.dataset.engravingArtworkNotes = 'true';
    notes.placeholder = 'Example: Place logo before the name, between words, after engraving, etc.';
    notes.value = saved?.notes || '';
    meta.append(notesLabel, notes);
    return meta;
  }

  function renderFileList(upload) {
    const list = upload.querySelector('[data-engraving-upload-list]');
    const storedInputs = getStoredUploads(upload);
    const savedValues = getMetaValues(upload);
    list.innerHTML = '';
    list.hidden = storedInputs.length === 0;
    storedInputs.forEach((input, index) => {
      const file = input.files && input.files[0];
      if (!file) return;
      const item = document.createElement('div');
      const row = document.createElement('div');
      const name = document.createElement('span');
      const remove = document.createElement('button');
      item.className = 'hikstik-engraving__file-item';
      row.className = 'hikstik-engraving__file-row';
      name.className = 'hikstik-engraving__file-name';
      name.textContent = file.name;
      remove.className = 'hikstik-engraving__remove';
      remove.type = 'button';
      remove.textContent = 'X';
      remove.setAttribute('aria-label', 'Remove ' + file.name);
      remove.addEventListener('click', () => {
        const filenameProperty = upload.querySelector('[data-engraving-file-name-property][data-upload-token="' + input.dataset.uploadToken + '"]');
        input.remove();
        filenameProperty?.remove();
        renderFileList(upload);
        renumberUploads(upload);
        ensureActiveUploadInput(upload);
      });
      row.append(name, remove);
      item.append(row, createMeta(upload, input, index, savedValues[input.dataset.uploadToken]));
      list.append(item);
    });
    renumberUploads(upload);
  }

  function storeUploadInput(input) {
    const upload = input.closest('[data-engraving-upload]');
    const file = input.files && input.files[0];
    if (!upload || !file) return;
    const token = Date.now() + '-' + Math.random().toString(36).slice(2);
    const filenameProperty = createHidden(upload.dataset.productFormId, 'properties[Artwork ' + (getStoredUploads(upload).length + 1) + ']', file.name, 'engravingFileNameProperty');
    input.dataset.engravingStoredUpload = 'true';
    input.dataset.uploadToken = token;
    input.classList.add('hikstik-engraving__stored-input');
    input.name = 'properties[_Artwork File ' + (getStoredUploads(upload).length + 1) + ']';
    input.id = input.id + '-stored';
    filenameProperty.dataset.uploadToken = token;
    upload.append(filenameProperty);
    ensureActiveUploadInput(upload);
    renderFileList(upload);
  }

  function ensureUploadField(container) {
    let upload = container.querySelector('[data-engraving-upload]');
    if (upload) {
      ensureActiveUploadInput(upload);
      ensureNoArtworkInput(upload);
      updateUploadStatus(upload);
      return upload;
    }
    const productFormId = container.dataset.productFormId;
    const error = container.querySelector('[data-engraving-error]');
    upload = document.createElement('div');
    upload.className = 'hikstik-engraving__upload';
    upload.dataset.engravingUpload = 'true';
    upload.dataset.productFormId = productFormId;
    upload.hidden = true;
    upload.innerHTML = '<label class="form__label">Have artwork/logo? Upload here:</label><div data-engraving-upload-inputs></div><button type="button" class="hikstik-engraving__choose" data-engraving-choose-artwork>Choose File</button><p class="hikstik-engraving__status" data-engraving-upload-status>No file uploaded</p><div class="hikstik-engraving__file-list" hidden aria-live="polite" data-engraving-upload-list></div><p class="hikstik-engraving__help caption">Accepted image files include JPG, PNG, WebP, HEIC, HEIF, and SVG. To add more than one image, choose a file, then choose another.</p>';
    container.insertBefore(upload, error || null);
    ensureNoArtworkInput(upload);
    ensureActiveUploadInput(upload);
    updateUploadStatus(upload);
    return upload;
  }

  function clearUpload(upload) {
    if (!upload) return;
    upload.querySelector('[data-engraving-upload-inputs]').innerHTML = '';
    upload.querySelector('[data-engraving-upload-list]').innerHTML = '';
    upload.querySelector('[data-engraving-upload-list]').hidden = true;
    upload.querySelectorAll('[data-engraving-file-name-property]').forEach((input) => input.remove());
    ensureActiveUploadInput(upload);
    updateUploadStatus(upload);
  }

  function updateCounter(input, counter) {
    if (!input || !counter) return;
    const max = Number(input.getAttribute('maxlength')) || 0;
    if (max && input.value.length > max) input.value = input.value.slice(0, max);
    counter.textContent = input.value.length + ' / ' + max;
  }

  function setFieldState(field, enabled, clearValue, label, propertyName) {
    if (!field) return;
    const input = field.querySelector('[data-engraving-input]');
    const counter = field.querySelector('[data-engraving-counter]');
    const labelEl = field.querySelector('label, .form__label');
    field.hidden = !enabled;
    if (!input) return;
    input.disabled = !enabled;
    input.required = false;
    input.removeAttribute('required');
    input.setAttribute('aria-required', 'false');
    if (labelEl && label) labelEl.textContent = label + ' (Max: 45 Characters)';
    if (label) input.setAttribute('aria-label', label + ' (Max: 45 Characters)');
    if (propertyName) input.name = 'properties[' + propertyName + ']';
    if (!enabled && clearValue) {
      input.value = '';
      input.setCustomValidity('');
    }
    updateCounter(input, counter);
  }

  function setUploadState(container, enabled, clearValue) {
    const upload = ensureUploadField(container);
    upload.hidden = !enabled;
    if (!enabled && clearValue) clearUpload(upload);
    upload.querySelectorAll('[data-engraving-upload-input]').forEach((input) => {
      input.disabled = !enabled;
    });
    updateUploadStatus(upload);
  }

  function setError(container, message) {
    const error = container.querySelector('[data-engraving-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function sync(container, options = {}) {
    const selectedValue = getSelectedEngravingValue(container);
    const previousMode = container.dataset.engravingMode || 'none';
    const previousOption = container.dataset.engravingOption || '';
    const mode = getMode(selectedValue);
    const layout = getLayout(selectedValue);
    const form = document.getElementById(container.dataset.productFormId);
    const clearHidden = options.clearHidden !== false;
    if (form) {
      form.enctype = 'multipart/form-data';
      form.encoding = 'multipart/form-data';
    }
    container.hidden = mode === 'none';
    container.dataset.engravingMode = mode;
    container.dataset.engravingOption = selectedValue;
    if (mode === 'one') {
      setFieldState(container.querySelector('[data-engraving-field="1"]'), true, clearHidden, 'Engraving', 'Engraving');
      setFieldState(container.querySelector('[data-engraving-field="2"]'), false, clearHidden, layout.secondLabel, layout.second);
    } else {
      setFieldState(container.querySelector('[data-engraving-field="1"]'), mode === 'two', clearHidden, layout.firstLabel, layout.first);
      setFieldState(container.querySelector('[data-engraving-field="2"]'), mode === 'two', clearHidden, layout.secondLabel, layout.second);
    }
    setUploadState(container, mode !== 'none', clearHidden);
    const upload = ensureUploadField(container);
    if ((mode !== previousMode || selectedValue !== previousOption) && getStoredUploads(upload).length) renderFileList(upload);
    setError(container, '');
    const paymentButton = form?.querySelector('.shopify-payment-button');
    const note = getBulkEngravingNote(container);
    if (paymentButton) paymentButton.hidden = mode !== 'none';
    if (note) {
      note.hidden = mode === 'none';
      updateBulkEngravingNote(note);
    }
  }

  function validateArtworkMeta(container, upload) {
    for (const meta of getMetaControls(upload)) {
      const side = meta.querySelector('[data-engraving-artwork-side]');
      const notes = meta.querySelector('[data-engraving-artwork-notes]');
      if (side && side.tagName === 'SELECT' && !side.value) {
        const message = 'Please choose where each artwork file should go before adding this shaft to your cart.';
        side.setCustomValidity(message);
        setError(container, message);
        side.reportValidity();
        side.focus();
        return false;
      }
      if (notes && !notes.value.trim()) {
        const message = 'Please add placement notes for each artwork file before adding this shaft to your cart.';
        notes.setCustomValidity(message);
        setError(container, message);
        notes.reportValidity();
        notes.focus();
        return false;
      }
    }
    return true;
  }

  function getArtworkSides(upload) {
    return getMetaControls(upload).map((meta) => meta.querySelector('[data-engraving-artwork-side]')?.value || '').filter(Boolean);
  }

  function validate(container) {
    sync(container, { clearHidden: true });
    const mode = container.dataset.engravingMode || 'none';
    if (mode === 'none') return true;
    const layout = getLayout(container.dataset.engravingOption || '');
    const upload = ensureUploadField(container);
    const engraving1 = container.querySelector('[data-engraving-input="1"]:not(:disabled)');
    const engraving2 = container.querySelector('[data-engraving-input="2"]:not(:disabled)');
    const hasEngraving1 = Boolean(engraving1?.value.trim());
    const hasEngraving2 = Boolean(engraving2?.value.trim());
    const hasArtwork = getStoredUploads(upload).length > 0;
    const artworkSides = getArtworkSides(upload);
    const firstCovered = hasEngraving1 || artworkSides.includes(layout.first) || artworkSides.includes('Both') || (mode === 'one' && hasArtwork);
    const secondCovered = hasEngraving2 || artworkSides.includes(layout.second) || artworkSides.includes('Both');
    const completedCount = [hasEngraving1, hasEngraving2, hasArtwork].filter(Boolean).length;
    const requiredCount = mode === 'two' ? 2 : 1;
    container.querySelectorAll('[data-engraving-input], [data-engraving-artwork-side], [data-engraving-artwork-notes]').forEach((input) => input.setCustomValidity(''));
    if (hasArtwork && !validateArtworkMeta(container, upload)) return false;
    if (mode === 'two' && hasArtwork && (!firstCovered || !secondCovered)) {
      const missing = !firstCovered ? layout.firstLabel : layout.secondLabel;
      const message = 'Please add engraving text or assign artwork for ' + missing + ' before adding this shaft to your cart.';
      const target = !firstCovered ? engraving1 : engraving2;
      if (target) {
        target.setCustomValidity(message);
        target.reportValidity();
        target.focus();
      }
      setError(container, message);
      return false;
    }
    if (completedCount >= requiredCount) {
      setError(container, '');
      return true;
    }
    const message = mode === 'two'
      ? 'Please complete at least two of these: ' + layout.firstLabel + ', ' + layout.secondLabel + ', or artwork upload.'
      : 'Please enter engraving text or upload artwork before adding this shaft to your cart.';
    const target = engraving1 || engraving2;
    if (target) {
      target.setCustomValidity(message);
      target.reportValidity();
      target.focus();
    }
    setError(container, message);
    return false;
  }

  function bind(container) {
    if (container.dataset.engravingBound === 'true') return;
    const form = document.getElementById(container.dataset.productFormId);
    container.dataset.engravingBound = 'true';
    container.addEventListener('input', (event) => {
      const input = event.target.closest('[data-engraving-input]');
      const metaInput = event.target.closest('[data-engraving-artwork-side], [data-engraving-artwork-notes]');
      if (input) updateCounter(input, container.querySelector('[data-engraving-counter="' + input.dataset.engravingInput + '"]'));
      if (input || metaInput) {
        event.target.setCustomValidity('');
        setError(container, '');
      }
    });
    container.addEventListener('click', (event) => {
      if (!event.target.closest('[data-engraving-choose-artwork]')) return;
      ensureActiveUploadInput(ensureUploadField(container)).click();
    });
    container.addEventListener('change', (event) => {
      const uploadInput = event.target.closest('[data-engraving-upload-input]:not([data-engraving-stored-upload])');
      const metaInput = event.target.closest('[data-engraving-artwork-side], [data-engraving-artwork-notes]');
      if (uploadInput) storeUploadInput(uploadInput);
      if (metaInput) {
        metaInput.setCustomValidity('');
        setError(container, '');
      }
    });
    if (form) {
      form.addEventListener('formdata', (event) => {
        if ((container.dataset.engravingMode || 'none') === 'none') return;
        if (getStoredUploads(ensureUploadField(container)).length === 0) event.formData.set('properties[Artwork 1]', 'No artwork');
      });
      form.addEventListener('submit', (event) => {
        if (validate(container)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    }
    sync(container, { clearHidden: true });
  }

  function init() {
    installStyles();
    document.querySelectorAll(SELECTOR).forEach(bind);
  }

  document.addEventListener('change', (event) => {
    if (!event.target.closest('variant-selects')) return;
    document.querySelectorAll(SELECTOR).forEach((container) => sync(container, { clearHidden: true }));
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('DOMContentLoaded', init);
  init();
})();
